module.exports = __webpack_public_path__ + "static/img/101865.03b7398a.png";